import Vue from 'vue';
import '@root/components/common';
import { createHead } from '@unhead/vue/client';

Vue.configureCompat({
    MODE: 3,
    COMPONENT_V_MODEL: false,
    RENDER_FUNCTION: false,
    ATTR_FALSE_VALUE: false,
    WATCH_ARRAY: false,
});

function createPage(page, propsCallback, beforeMountCallback) {
    const el = document.getElementById('app');
    createPageAt(el, page, propsCallback, beforeMountCallback);
}


export async function createPageAt(el, page, propsCallback, beforeMountCallback) {    
    const json = el.dataset.json;
    const baseJson = el.dataset.baseJson;

    let data = json ? JSON.parse(json) : {};
    let baseData = baseJson ? JSON.parse(baseJson) : {};

    console.log('Input data', data, baseData);

    var props = {
        "data": data.data ?? data,
        "baseData": baseData.data,
    };

    if (propsCallback) {
        propsCallback(props);
    } 

    if (typeof page === 'function') {
        const loader = page(props);
        const module = await loader();
        page = module['default'];
    }
    const app = Vue.createApp({ 
        setup() {
            return () => Vue.h(page, props);
        }
    });
    app.config.compilerOptions.whitespace = 'condense';
    
    if (beforeMountCallback) {
        beforeMountCallback(app);
    }

    try {
        app.use(createHead());
    } catch(e) {
        let { createHead } = await import('@unhead/vue/client'); // have a timing issue with plugin load: auth form from main_menu.js does not see 'createHead' variable
        app.use(createHead());
    }

    app.mount(el);

    return app;
}

export default createPage;